import { Icon } from "Components";
import Icons from "Components/Icon/Icons";

const GridReportCard = ({ label, desc, iconType } : { label: string, desc: string, iconType: keyof typeof Icons }) => {
    return <div className="card-content">
    <Icon type={iconType} />
    <div className="text">
        <div className="label" style={{ textTransform: "capitalize" }}>{label}</div>
        <div className="description">{desc}</div>
    </div>
</div>
}

export default GridReportCard;